module.exports = __webpack_public_path__ + "img/map.e6033138.png";